<template>
	<div class="input search">
		<div class="search-wrapper">
			<i class="ss-search ss-glyphish-filled"></i>
			<input @input="search"
				v-model="term"
				type="text"
				class="search"
				name="search"
				:placeholder="defaultText"
				id="search"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: ['items', 'defaultText'],
	data() {
		return {
			term: '',
			foundItems: []
		}
	},
	methods: {
		search() {
			this.foundItems = [];
			if(this.items.length > 0) {
				this.items.forEach(item => {
					if(item.name.toLowerCase().includes(this.term.toLowerCase())) {
						this.foundItems.push(item)
					}
				})
			}
			this.$emit('foundItems', this.foundItems)
		}
	}
}
</script>

<style lang="scss">

</style>>



// WEBPACK FOOTER //
// src/components/Form/Search.vue